import { graphql } from '../../../gql';

// TRIL-349: single-reply read for the reply detail page. Mirrors
// GET_POST_BY_ID_QUERY but scoped to the fields the reply page renders
// (parent link, body, score, interaction counts). Backed by the
// getReplyById resolver (POSTREPLY# read).
export const GET_REPLY_BY_ID_QUERY = graphql(`
  query getReplyById($replyId: String!) {
    getReplyById(replyId: $replyId) {
      id
      status
      createdAt
      updatedAt
      depth
      replyCount
      parentPostId
      rootPostId
      authorId
      username
      score
      textBlocks {
        ...TextBlockFields
      }
      postAnalytics {
        id
        author {
          username
          userId
        }
        metrics {
          replyCount
          bookmarkCount
          votesCount {
            upVotes
            downVotes
          }
        }
      }
      viewerInteractions {
        ...ViewerInteractionFields
        likeCount
        bookmarkCount
        reachCount
      }
    }
  }
`);
